import { ChangeEvent } from "react";
import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import commonStyles from "@styles/common.less";
import styles from "./messaging-template-content-form-section.less";
import { MessagingTemplateContentValidationErrors } from "@idw-types/common/validation/messaging-template/messaging-template-validation-errors";

type MessagingTemplateContentFormSectionProps = {
    state: FormattedMessagingTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: MessagingTemplateContentValidationErrors;
    handleUpdateTemplate: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const MessagingTemplateContentFormSection = (props: MessagingTemplateContentFormSectionProps) => {
    const {
        state,
        isDisabled,
        labelWidth,
        validationErrors,      
        handleUpdateTemplate
    } = props;

    const resource = resources.pages.messagingTemplateDetails.tabs.content;
    return (
        <ThemingFormSection title={resource.sections.template.title}>
            <div className={commonStyles.sectionDescription}>{resource.sections.template.description}</div>
            <TextareaFormGroup
                className={styles.expandedTextArea}
                controlId="messaging-template-template-input"
                automationId="messaging-template-template-input"
                label={resource.inputs.template.label}
                ariaLabel={resource.inputs.template.label}
                placeholder={resource.inputs.template.placeholder}
                value={state.template}
                onChange={handleUpdateTemplate}
                disabled={isDisabled}
                isRequired={true}
                labelWidth={labelWidth}
                layout={LayoutTypes.COLUMN}
            />
            {validationErrors?.requiredVariableError}
        </ThemingFormSection>
    );
}